import { ActionButtonItemWithoutValue } from '../button/action'
import { SwitchColorEnum, SwitchLabelPositionEnum } from '../switch/switch.types'

interface IconAction {
  icon: string
  onClick: () => void
  'aria-label'?: string
  disabled?: boolean
}

export interface TextAction {
  text: string
  onClick: () => void
  'aria-label'?: string
}

export interface SwitchAction {
  switchLabel: string
  isChecked?: boolean
  onCheckedChange?: (isChecked: boolean) => void
  labelPosition?: SwitchLabelPositionEnum
  color?: SwitchColorEnum
  'aria-label'?: string
}

type Action = IconAction | TextAction | SwitchAction

export function isIconAction(action: Action): action is IconAction {
  return 'icon' in action
}

export function isSwitchAction(action: Action): action is SwitchAction {
  return 'switchLabel' in action
}

export interface AccordionProps {
  id?: string
  title?: string
  titleClassName?: string
  titleComponent?: React.ReactNode
  children: React.ReactNode
  startAdornment?: React.ReactNode
  endSlot?: React.ReactNode
  actions?: Action[]
  actionsContainerClassName?: string
  actionButtonItems?: ActionButtonItemWithoutValue[]
  defaultOpen?: boolean
  collapsible?: boolean
  padded?: boolean
  size?: 'small' | 'medium' | 'large' | 'xlarge'
  className?: string
  contentClassName?: string
  headerClassName?: string
  onValueChange?: (value: string) => void
  triggerPosition?: 'start' | 'end'
  triggerDisabled?: boolean
}
